import { render } from "./DfqView.vue?vue&type=template&id=ce605be2&scoped=true"
import script from "./DfqView.vue?vue&type=script&lang=js"
export * from "./DfqView.vue?vue&type=script&lang=js"

import "./DfqView.vue?vue&type=style&index=0&id=ce605be2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ce605be2"]])

export default __exports__